
  <div class="text-center p-4">
    <div class="mb-3 d-flex justify-content-end">
      <img class="c-pointer" src="assets/images/close-movie.svg" alt="" (click)="close()" height="24" width="24">
    </div>
    <img [ngClass]="{'smallSdg':isSdgSmall}" [src]="data.image" alt="" class="max-ht-80vh max-wd-100">
  </div>
<!-- <div class="w-100">
  <img style="max-width: 80vw;max-height: 90vh;" class="img-fluid" [src]="data.image" alt="">
</div> -->
